import { c as _c } from "react/compiler-runtime";
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { SubContentProps } from '../dropdown.types';
const SubContent = forwardRef<HTMLDivElement, SubContentProps>((t0, ref) => {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cx("min-w-[120px] max-w-[min(360px,calc(100vw-32px))]", "bg-elevated rounded-default border border-tertiary origin-[var(--radix-dropdown-menu-content-transform-origin)] overflow-auto z-[60] shadow-md", "data-[side=bottom]:animate-[slideDown_var(--duration-ultra-fast)]", "data-[side=top]:animate-[slideUp_var(--duration-ultra-fast)]", "data-[side=left]:animate-[slideRight_var(--duration-ultra-fast)]", "data-[side=right]:animate-[slideLeft_var(--duration-ultra-fast)]", "data-[state=open]:animate-[scaleIn_var(--duration-ultra-fast)]", "data-[state=closed]:animate-[scaleOut_var(--duration-ultra-fast)]", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = <RadixDropdown.SubContent ref={ref} className={t1} {...props}>{children}</RadixDropdown.SubContent>;
    $[6] = children;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
export default SubContent;